import { Form } from "@circle-react-uikit/Form";
import { LinkInput } from "@circle-react-uikit/Form/LinkInput";
import { VALIDATION_SCHEMA } from "@circle-react-uikit/TipTapBlockEditor/AddTipTapLinkModal/validationSchema";
import { Button } from "@circleco/compass/components/Button";
import { Modal } from "@circleco/compass/components/Modal";
import type { Editor } from "@tiptap/react";

import { t } from "@/i18n-js/instance";

const FORM_ID = "email-image-link-form";

interface ImageLinkModalComponentProps {
  editor: Editor;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const ImageLinkModalComponent = ({
  editor,
  onOpenChange,
  open,
}: ImageLinkModalComponentProps) => {
  const previousURL = editor.getAttributes("image").href;
  const isEditable = Boolean(previousURL);

  const handleRemoveLink = () => {
    editor.chain().updateAttributes("image", { href: null }).run();
    onOpenChange(false);
  };

  const handleSubmit = ({ url }: { url: string }) => {
    editor.chain().updateAttributes("image", { href: url }).run();
    onOpenChange(false);
  };

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="md">
      <Modal.Content>
        <Modal.Header
          title={
            isEditable
              ? t("tiptap.extensions.link.edit")
              : t("tiptap.extensions.link.add")
          }
          showCloseButton
        />
        <Modal.Body>
          <Form
            id={FORM_ID}
            onSubmit={handleSubmit}
            defaultValues={{ url: previousURL }}
            validationSchema={VALIDATION_SCHEMA}
            autoComplete="off"
          >
            <Form.Item
              hideDescription
              hideBorder
              isFirstChild
              fullWidth
              name="url"
              label={t("tiptap.extensions.link.link")}
            >
              <LinkInput name="url" />
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer
          startContent={
            isEditable && (
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={handleRemoveLink}
              >
                {t("tiptap.extensions.link.remove")}
              </Button>
            )
          }
          secondaryAction={{
            label: t("cancel"),
            onClick: () => onOpenChange(false),
          }}
          primaryAction={{
            label: t("tiptap.extensions.link.save"),
            type: "submit",
            form: FORM_ID,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
